import {ESprintenTeam} from '@repo/shared/Customer/Coop/SprintenTeams/SprintenTeams.types'
import {atomWithReset} from 'jotai/utils'

interface IActiveSlots {
  slot1: null | ESprintenTeam
  slot2: null | ESprintenTeam
  slot3: null | ESprintenTeam
  slot4: null | ESprintenTeam
  slot5: null | ESprintenTeam
}

export const activeSlotsState = atomWithReset<IActiveSlots>({
  slot1: null,
  slot2: null,
  slot3: null,
  slot4: null,
  slot5: null,
})
